import * as api from '../../lib/api';

export const LOAD_PRODUCTIVITY_FOR_GROWER_BEGIN =
  'LOAD_PRODUCTIVITY_FOR_GROWER_BEGIN';
export const LOAD_PRODUCTIVITY_FOR_GROWER_END =
  'LOAD_PRODUCTIVITY_FOR_GROWER_END';
export const LOAD_PRODUCTIVITY_FOR_GROWER_ERROR =
  'LOAD_PRODUCTIVITY_FOR_GROWER_ERROR';
export const SET_APPROVAL_BEGIN = 'SET_APPROVAL_BEGIN';
export const SET_APPROVAL_END = 'SET_APPROVAL_END';
export const SET_APPROVAL_ERROR = 'SET_APPROVAL_ERROR';

function loadProductivityForGrowerBegin(growerId) {
  return {
    type: LOAD_PRODUCTIVITY_FOR_GROWER_BEGIN,
    growerId,
  };
}

function loadProductivityForGrowerEnd(data) {
  return {
    type: LOAD_PRODUCTIVITY_FOR_GROWER_END,
    data,
  };
}

function loadProductivityForGrowerError(error) {
  return {
    type: LOAD_PRODUCTIVITY_FOR_GROWER_ERROR,
    error,
  };
}

export function loadProductivityForGrower(growerId) {
  return (dispatch) => {
    dispatch(loadProductivityForGrowerBegin(growerId));

    return api.getProductivityForGrower(growerId).then(
      (data) => dispatch(loadProductivityForGrowerEnd(data)),
      (error) => dispatch(loadProductivityForGrowerError(error)),
    );
  };
}

function setApprovalBegin(field, isApproved) {
  return {
    type: SET_APPROVAL_BEGIN,
    field,
    isApproved,
  };
}

function setApprovalEnd(data) {
  return {
    type: SET_APPROVAL_END,
    data,
  };
}

function setApprovalError(error) {
  return {
    type: SET_APPROVAL_ERROR,
    error,
  };
}

export function setApproval(field, isApproved) {
  return (dispatch) => {
    dispatch(setApprovalBegin(field, isApproved));

    return api.setProductivityApproval(field.aaManagedId, isApproved).then(
      (data) => dispatch(setApprovalEnd(data)),
      (error) => dispatch(setApprovalError(error)),
    );
  };
}
